export enum CONDITION_STRUCTURE {
    SOURCE = "source",
    CONDITION = "condition",
    TARGET = "target"
}

export enum CONDITION_OPERATOR {
    AND = "AND",
    OR = "OR"
}

export enum SOURCE_OPTIONS {
    //API
    USER = "User",
    ROLE = "Role",
    PRODUCT_IN_CART = "Product in cart",

    // ACTIVE LSD ENTITY
    ACTIVE_PRODUCT = "Active product",
    ACTIVE_CUSTOMER = "Active customer",
    CUSTOMER_IN_CART = "Customer in cart",
    ACTIVE_ORDER = "Active order",

    //VALUE INPUT
    NUMBER_OF_PRODUCT_IN_CART = "# of products in cart",
    CART_VALUE = "Cart Value",
    IDLE_TIME = "Time idle",

    //New Order trigger
    NEW_ORDER = "New order"
}

export enum CONDITION_ACTION {
    HIDE = "Hide",
    SHOW = "Show",
    DISABLE = "Disable",
    AUTHENTICATE = "Authenticate"
}

export enum CONDITION_DECISION {
    IS = "is",
    IS_NOT = "is not",
    MORE_THAN = "more than",
    LESS_THAN = "less than",
    CONTAINS_ANY_OF = "contains any of",
    DOES_NOT_CONTAIN_ANY_OF = "does not contain any of",
    CONTAINS_ALL_OF = "contains all of",
    DOES_NOT_CONTAIN_ALL_OF = "does not contain all of"
}

export enum CONDITION_SOURCE {
    PRODUCT = "product",
    USER = "user",
    ROLE = "role",
    PRODUCT_IN_CART = "product in cart",
    ACTIVE = "active",
    CUSTOMER = "customer",
    CUSTOMER_IN_CART = "customer in cart",
    ORDER = "order"
}

export enum ReceiptLayoutType {
    TITLE = "productTitle",
    PRICE = "productPrice",
    VARIATION = "productVariation",
    SKU = "sku",
    DESCRIPTION = "productDescription",
    DISCOUNT = "productDiscount",
    TAX = "productTax",
    TOTAL = "productTotal",
    TOTAL_PRICE = "productTotalPrice",
    CART_TOTAL = "cartTotal",
    PAYMENT = "cartPayment",
    EMV = "cartEMV"
}

export enum ReceiptSettingsType {
    VALUES = "showValues",
    VARIATIONS = "showVariations",
    NOTES = "showNotes",
    SKU = "showSku",
    DESCRIPTION = "showDescription",
    TAXES = "taxes",
    CART_TAXES = "showCartTaxes",
    PRODUCT_TAXES = "showProductTaxes",
    DISCOUNT = "discount",
    CART_DISCOUNT = "showCartDiscount",
    PRODUCT_DISCOUNT = "showProductDiscount",
    TIPS = "showTips",
    FEE = "showFee",
    CART_FEE = "showCartFee",
    PRODUCT_FEE = "showProductFee",
    SIGNATURE = "showSignature"
}

export enum MongoTables {
    COMPANIES = "companies",
    PRODUCTS = "products",
    ORDERS = "orders",
    REFUNDS = "refunds",
    CUSTOMERS = "customers",
    BUILDS = "builds",
    CATEGORIES = "categories",
    VARIANTS = "variants",
    MANAGED_BUILDS = "managedBuilds",
    ROLES = "roles",
    USERS = "users"
}
